<template>
	<div class="edit-campaign-router">
		<div v-if="loading" class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
			<div class="text-center">
				<i class="fad fa-spinner fa-spin fa-3x text-primary mb-3"></i>
				<p class="text-muted">Loading campaign...</p>
			</div>
		</div>
		<div v-else-if="error" class="container">
			<div class="alert alert-danger mt-4">
				<i class="fad fa-exclamation-triangle me-2"></i>
				{{ error }}
			</div>
		</div>
	</div>
</template>

<script>
import restApi from '../../api/index'

export default {
	name: 'EditAutoCampaignRouter',
	data() {
		return {
			loading: true,
			error: null,
			campaignId: null
		}
	},
	async created() {
		this.campaignId = this.$route.params.id;
		if (!this.campaignId) {
			this.error = 'Campaign ID is required';
			this.loading = false;
			return;
		}
		
		await this.loadCampaignAndRedirect();
	},
	methods: {
		async loadCampaignAndRedirect() {
			try {
				// Load campaign data to check has_sequences attribute
				const response = await restApi.get(`/auto-campaigns/${this.campaignId}`);
				const campaign = response.data;
				
				// Redirect based on has_sequences attribute
				if (campaign.has_sequences && campaign.has_sequences > 0) {
					// Redirect to sequences edit view
					this.$router.replace({ 
						name: 'editAutoCampaignWithSequences', 
						params: { id: this.campaignId } 
					});
				} else {
					// Redirect to triggers edit view
					this.$router.replace({ 
						name: 'editAutoCampaignWithTriggers', 
						params: { id: this.campaignId } 
					});
				}
			} catch (error) {
				console.error('Error loading campaign:', error);
				
				if (error.response && error.response.status === 404) {
					this.error = 'Campaign not found';
				} else {
					this.error = 'Failed to load campaign data';
				}
				this.loading = false;
				
				// Redirect to campaigns list after showing error
				setTimeout(() => {
					this.$router.push({ name: 'autoCampaigns' });
				}, 3000);
			}
		}
	}
}
</script>

<style scoped>
.edit-campaign-router {
	min-height: 100vh;
	background-color: #f8f9fa;
}
</style>